import publicPages from '../../../content/publicPages';

//Generelle Routen
const routes =  [
    {   path: '/',
        name: '',
        component: () => import(/* webpackChunkName: "welcome" */ '../../../views/component/welcome'),
        meta: {authLevels: [0], seo: publicPages.landing.seo}
    },

    {   path: '/impressum',
        name: 'impressum',
        component: () => import(/* webpackChunkName: "legal" */ '../../../views/component/LegalPage'),
        props: {page: 'impressum'},
        meta: {authLevels: [0], seo: publicPages.impressum.seo}
    },

    // Router matcht ohne Groß-/Kleinschreibung, alte Links auf /Datenschutz landen also auch hier
    {   path: '/datenschutz',
        name: 'datenschutz',
        component: () => import(/* webpackChunkName: "legal" */ '../../../views/component/LegalPage'),
        props: {page: 'datenschutz'},
        meta: {authLevels: [0], seo: publicPages.datenschutz.seo}
    },

    // Alte Adresse des Impressums
    {   path: '/about',
        redirect: '/impressum'
    },

    {   path: '/contactus',
        name: 'contactus',
        component: () => import(/* webpackChunkName: "about" */ '../../../views/component/ContactUs'),
        meta: {authLevels: [1,2]}
    },

    {   path: '/register',
        name: 'register',
        component: () => import(/* webpackChunkName: "register" */ '../../../views/component/register'),
        meta: {
            authLevels: [0],
            seo: {
                path: '/register',
                title: 'Registrieren | schuetzenbuch.de',
                description: 'Konto für Schützen oder Vereine auf schuetzenbuch.de anlegen, dem digitalen Schießbuch.'
            }
        }
    },

    {   path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "login" */ '../../../views/component/login'),
        meta: {
            authLevels: [0],
            seo: {
                path: '/login',
                title: 'Anmelden | schuetzenbuch.de',
                description: publicPages.site.description,
                index: false
            }
        }
    },

    {   path: '/loginQR',
        name: 'loginQR',
        component: () => import(/* webpackChunkName: "login" */ '../../../views/component/loginwithQRCode'),
        meta: {authLevels: [0]}
    },

    // {   path: '/club/register',
    //     name: 'clubregister',
    //     component: () => import(/* webpackChunkName: "register" */ '../../../views/component/register'),
    //     meta: {authLevels: [0]}
    // },
    //
    // {   path: '/club/login',
    //     name: 'clublogin',
    //     component: () => import(/* webpackChunkName: "login" */ '../../../views/component/login'),
    //     meta: {authLevels: [0]}
    // },

];

export default routes
